// Internal Dependencies
import { firebaseRef } from '../../../../config/constants';
import {
  updatePageAction,
  updateRowsPerPageAction,
  selectedNinjasAction,
  selectAllNinjasAction,
  searchStringAction,
} from './action-creators';

export const updatePage = page =>
    dispatch =>
        dispatch(updatePageAction(page));

export const updateRowsPerPage = rows =>
  dispatch =>
    dispatch(updateRowsPerPageAction(rows));

export const updateSelectedNinjas = ninjas =>
  dispatch =>
    dispatch(selectedNinjasAction(ninjas));

export const selectAllNinjas = rows =>
  dispatch =>
    dispatch(selectAllNinjasAction(rows));

export const searchString = query =>
  dispatch =>
    dispatch(searchStringAction(query));

export const addNinja = (ninjaObj) => {
  firebaseRef.child('coders').child(ninjaObj.key).set(ninjaObj);
};

export const updateNinja = (updatedNinja) => {
  firebaseRef.child('coders').child(updatedNinja.key).update(updatedNinja);
};



/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/actions/actions.js
 **/